// Common EventBus for the App

import EventEmitter from 'events'

class EventBus extends EventEmitter {
    // EventBus
}

const eb = new EventBus();
export default eb;


// WEBPACK FOOTER //
// ./src/utils/EventBus.js